import { I18n } from '@calendly/i18n'

const map = {
  answer_1: () => I18n.t('publisher.components.editor.variables_new.answer_1'),
  answer_2: () => I18n.t('publisher.components.editor.variables_new.answer_2'),
  answer_3: () => I18n.t('publisher.components.editor.variables_new.answer_3'),
  answer_4: () => I18n.t('publisher.components.editor.variables_new.answer_4'),
  answer_5: () => I18n.t('publisher.components.editor.variables_new.answer_5'),
  answer_6: () => I18n.t('publisher.components.editor.variables_new.answer_6'),
  answer_7: () => I18n.t('publisher.components.editor.variables_new.answer_7'),
  answer_8: () => I18n.t('publisher.components.editor.variables_new.answer_8'),
  answer_9: () => I18n.t('publisher.components.editor.variables_new.answer_9'),
  answer_10: () => I18n.t('publisher.components.editor.variables_new.answer_10'),
  canceled_by: () => I18n.t('publisher.components.editor.variables_new.canceled_by'),
  confirmation_link: () => I18n.t('publisher.components.editor.variables_new.confirmation_link'),
  event_date: () => I18n.t('publisher.components.editor.variables_new.event_date'),
  event_description: () => I18n.t('publisher.components.editor.variables_new.event_description'),
  event_duration: () => I18n.t('publisher.components.editor.variables_new.event_duration'),
  event_link: () => I18n.t('publisher.components.editor.variables_new.event_link'),
  event_name: () => I18n.t('publisher.components.editor.variables_new.event_name'),
  event_organizer_name: () => I18n.t('publisher.components.editor.variables_new.event_organizer_name'),
  event_time: () => I18n.t('publisher.components.editor.variables_new.event_time'),
  event_times: () => I18n.t('publisher.components.editor.variables_new.event_times'),
  how_we_will_connect: () => I18n.t('publisher.components.editor.variables_new.how_we_will_connect'),
  invitees_count: () => I18n.t('publisher.components.editor.variables_new.invitees_count'),
  invitee_email: () => I18n.t('publisher.components.editor.variables_new.invitee_email'),
  invitee_first_name: () => I18n.t('publisher.components.editor.variables_new.invitee_first_name'),
  invitee_full_name: () => I18n.t('publisher.components.editor.variables_new.invitee_full_name'),
  invitee_last_name: () => I18n.t('publisher.components.editor.variables_new.invitee_last_name'),
  invitee_name: () => I18n.t('publisher.components.editor.variables_new.invitee_name'),
  invitee_phone_number: () => I18n.t('publisher.components.editor.variables_new.invitee_phone_number'),
  invitee_uuid: () => I18n.t('publisher.components.editor.variables_new.invitee_uuid'),
  location: () => I18n.t('publisher.components.editor.variables_new.location'),
  meeting_notes: () => I18n.t('publisher.components.editor.variables_new.meeting_notes'),
  my_name: () => I18n.t('publisher.components.editor.variables_new.my_name'),
  publisher_name: () => I18n.t('publisher.components.editor.variables_new.publisher_name'),
  questions_and_answers: () => I18n.t('publisher.components.editor.variables_new.questions_and_answers'),
  routing_form_questions_and_answers: () => I18n.t('publisher.components.editor.variables_new.routing_form_questions_and_answers'),
  team_member_name: () => I18n.t('publisher.components.editor.variables_new.team_member_name'),
  utm_source: () => I18n.t('publisher.components.editor.variables_new.utm_source'),
  utm_medium: () => I18n.t('publisher.components.editor.variables_new.utm_medium'),
  utm_campaign: () => I18n.t('publisher.components.editor.variables_new.utm_campaign'),
  utm_content: () => I18n.t('publisher.components.editor.variables_new.utm_content'),
  utm_term: () => I18n.t('publisher.components.editor.variables_new.utm_term')
}

export const getLocalizedVariableName = (variable) => {
  const mappedFn = map[variable]
  if (mappedFn) { return mappedFn() }

  return variable
}
